import { FC } from 'react'
import { Chip, SxProps, Theme, Tooltip } from '@mui/material'
import { CLASSE_SCORE_LABEL, ClasseScore, classeScoreChipColor } from '@/types/scoreComercial'

interface ClasseScoreChipProps {
  /** Classe que veio do backend; ausente = backend anterior à V47 → "—". */
  classe?: ClasseScore | null
  sx?: SxProps<Theme>
}

/**
 * Chip da classe do Score Comercial (PDF §2.3: o card mostra a classe, o detalhe mostra
 * as dimensões). A classe vem pronta do backend — este componente só a veste com a cor
 * semântica do tema. Sem classe, mostra "—" e diz por quê no tooltip.
 */
export const ClasseScoreChip: FC<ClasseScoreChipProps> = ({ classe, sx }) => (
  <Tooltip
    title={
      classe
        ? 'Classe do Score Comercial — derivada da etapa, nunca digitada'
        : 'Score Comercial indisponível nesta resposta'
    }
  >
    <Chip
      data-testid="chip-classe-score"
      label={classe ? CLASSE_SCORE_LABEL[classe] : '—'}
      color={classe ? classeScoreChipColor(classe) : 'default'}
      size="small"
      variant={classe ? 'filled' : 'outlined'}
      sx={{ height: 20, fontSize: '0.65rem', fontWeight: 600, ...sx }}
    />
  </Tooltip>
)
